import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
  standalone: true,
  imports: [TegelModule],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class WelcomeComponent {}
